import { IOptionsWithTypes } from '@eventr/common'
import { ColoursObj, drawerStore, Typography } from '@eventr/common-storybook'
import { Box, Stack } from '@mui/material'
import { useShallow } from 'zustand/react/shallow'
import { DirectChatButton } from '../../../home/components/directChatButton'
import { TeamMember } from '../../../home/overlay/TeamMember'
import { MemberProfilePic } from '../../../home/team/MemberProfilePic'
import { bs, useBoundStore } from '../../../state/bound.store'
import { useUserFilter } from '../hooks/useUserFilter'
import { useObjectContext } from '../providers/objectProvider'
export interface IUsersListProps {
    userList: IOptionsWithTypes[]
    showChat?: boolean
    subInfo?: React.ReactNode
}

export const UsersList = ({
    userList,
    showChat = true,
    subInfo,
}: IUsersListProps) => {
    const { past } = useObjectContext()
    const { filterUsers } = useUserFilter()
    const { getCurrentUser } = useBoundStore(
        useShallow((s) => {
            return {
                getCurrentUser: s.getCurrentUser,
            }
        })
    )

    const users = filterUsers(userList)
    const currentUser = getCurrentUser()

    return (
        <Stack spacing="8px" marginTop="8px">
            {users.map((user, rowId) => (
                <Stack
                    key={rowId}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Stack
                        spacing="16px"
                        direction="row"
                        alignItems={'center'}
                        onClick={() => {
                            /// Should not be able to select self
                            if (currentUser && user.id !== currentUser.id) {
                                useBoundStore
                                    .getState()
                                    .setOverride(user.id, false)
                                drawerStore().openDrawer({
                                    node: <TeamMember />,
                                })
                            }
                        }}
                    >
                        <MemberProfilePic user={user} />
                        <Box>
                            <Typography
                                id={'userNames'}
                                variant="bodyRegular"
                                color={
                                    past
                                        ? ColoursObj.shades.shade2
                                        : ColoursObj.font.primary
                                }
                                width={'56vw'}
                                overflow={'hidden'}
                                textOverflow={'ellipsis'}
                            >
                                {bs().getNameFormatted(user)}
                            </Typography>
                            {subInfo}
                        </Box>
                    </Stack>

                    {user.id !== currentUser?.id &&
                        user.firstName &&
                        user.lastName &&
                        showChat && (
                            <DirectChatButton
                                user_id={currentUser?.id ?? -1}
                                user_id2={user.id}
                                fullWidth={false}
                                past={past}
                            />
                        )}
                </Stack>
            ))}
        </Stack>
    )
}
